import { useEffect } from "react";

/**
 * Custom hook to handle keyboard events.
 *
 * @param {string} event - The key name to listen for (e.g., "Enter", "Escape").
 * @param {Function} callback - The function to execute when the specified key is pressed.
 *
 * @example
 * useKeyboardEvent('Enter', () => {
 *   console.log('Enter key pressed');
 * });
 *
 * @returns {void}
 */
const useKeyboardEvent = (event, callback) => {
  if (typeof callback !== "function") {
    throw new TypeError("The 'callback' parameter must be a function.");
  }

  useEffect(() => {
    const handleKeyUp = (e) => {
      if (e.key === event) {
        e.preventDefault();
        callback();
      }
    };
    document.addEventListener("keyup", handleKeyUp);
    return () => {
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, [event, callback]);
};

export default useKeyboardEvent;
